<template>
	<div class="filter appointments" >
		<h1 class="thermo">Filter</h1>
		<div class="filter-item">
			<span @click="emitFilterChange('default')">Alle afspraken</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'default'"
				@change="emitFilterChange('default')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('historic')">Verleden</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'historic'"
				@change="emitFilterChange('historic')"
			/>
		</div>
		<div class="historic-input-container" v-if="currentFilter === 'historic'">
			Van <DateField v-model="historicFromDate" @change="emitFilterChange(currentFilter)"></DateField>
			T/m <DateField v-model="historicTillDate" @change="emitFilterChange(currentFilter)"></DateField>
		</div>
		<div
			v-for="day in daysOfTheWeek"
			:key="day.value"
			class="filter-item"
		>
			<span @click="emitFilterChange(`${day.value}`)">{{ day.name }}</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === `${day.value}`"
				@change="emitFilterChange(`${day.value}`)"
			/>
		</div>

		<h1 class="thermo">Type</h1>
		<div class="filter-item">
			<span @click="setTypeFilter('all')">Alle types</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'all'"
				@change="setTypeFilter('all')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('bodemisolatie')">Bodemisolatie</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'bodemisolatie'"
				@change="setTypeFilter('bodemisolatie')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('gilde')">Gilde</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'gilde'"
				@change="setTypeFilter('gilde')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('impregneren')">Impregneren</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'impregneren'"
				@change="setTypeFilter('impregneren')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('spouwmuurisolatie')">Spouwmuurisolatie</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'spouwmuurisolatie'"
				@change="setTypeFilter('spouwmuurisolatie')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('leeghalen-spouwmuur')">Leeghalen Spouwmuurisolatie</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'leeghalen-spouwmuur'"
				@change="setTypeFilter('leeghalen-spouwmuur')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('support')">Support</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'support'"
				@change="setTypeFilter('support')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('ventilatierooster')">Ventilatierooster</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'ventilatierooster'"
				@change="setTypeFilter('ventilatierooster')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setTypeFilter('vloerisolatie')">Vloerisolatie</span>
			<ToggleField
				type="radio"
				name="typeFilter"
				:checked="typeFilter === 'vloerisolatie'"
				@change="setTypeFilter('vloerisolatie')"
			/>
		</div>
		<h1 class="thermo">Ploeg</h1>
		<div class="filter-item" v-for="van in vans">
			<span @click="setVanFilter(van.id)">{{ van.display_name }}</span>
			<ToggleField
				type="radio"
				:name="'vanFilter' + van.id"
				:checked="selectedVans.includes(van.id)"
				@click="setVanFilter(van.id)"
			/>
		</div>
	</div>
</template>

<script>
import DateField from "@/components/DateField.vue";
import ToggleField from "@/components/ToggleField.vue";
import {client} from "@/store";
import moment from "moment";

export default {
	components: {
		DateField,
		ToggleField,
	},

	props: {
		filter: String,
	},
	watch: {
		filter() {
			if(this.filter === this.currentFilter){
				return;
			}
			this.currentFilter = this.filter;
			this.emitFilterChange(this.filter);
		}
	},

	data() {
		return {
			historicFromDate: moment().subtract(6, 'months').format('DD-MM-YYYY'),
			historicTillDate: moment().format('DD-MM-YYYY'),
			afterDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
			currentFilter: 'default',
			typeFilter: 'all',
			vans: [],
			selectedVans: [],
			typeToRole: {
				"bodemisolatie": ["GROUND"],
				"gilde": null,
				"impregneren": ["IMPREGNEREN"],
				"spouwmuurisolatie": ["FTX1", "THERMO_FOAM"],
				"support": "SUPPORT",
				"ventilatierooster": "SUPPORT",
				"vloerisolatie": ["FLOOR"],
			}
		};
	},

	mounted() {
		this.getVans();
		this.currentFilter = this.daysOfTheWeek[0].value;
		this.emitFilterChange(this.currentFilter);
	},

	computed: {
		daysOfTheWeek() {
			const days = [];

			for (let i = 0; i < 7; i++) {
				const day = moment().locale("nl").add(i, "day");
				const dayName = day.format("dddd");

				if (["zaterdag", "zondag"].indexOf(dayName) === -1) {
					days.push({
						name: dayName.charAt(0).toUpperCase() + dayName.slice(1),
						value: day.format("YYYY-MM-DD")
					});
				}
			}

			return days;
		},
	},
	methods: {
		setVanFilter(id) {
			if (this.selectedVans.includes(id)) {
				this.selectedVans = this.selectedVans.filter(vanId => vanId !== id);
			} else {
				this.selectedVans.push(id);
			}
			this.emitFilterChange(this.currentFilter);
		},
		setTypeFilter(name) {
			this.typeFilter = name;
			this.selectedVans = [];
			this.getVans(this.typeToRole[name])
			this.emitFilterChange(this.currentFilter);
		},
		emitFilterChange(filter) {
			this.currentFilter = filter;
			this.$emit('filterChange', {
				filter: this.currentFilter,
				filterType: "appointments",
				afterDate: this.afterDate,
				historicFromDate: this.historicFromDate,
				historicTillDate: this.historicTillDate,
				appointmentType: this.typeFilter,
				vansFilter: this.selectedVans.length > 0 ? this.selectedVans : null
			});
		},
		getVans(role) {
			let filterRoles = ["THERMO_FOAM", "GROUND", "FLOOR", "SUPPORT", "FTX1", "IMPREGNEREN"];
			if(role === 'SUPPORT') {
				return this.getVansWithSupportProjects();
			}
			if(role != null) {
				filterRoles = role;
			}

			client.query(`
				query($roles: [String], $orderBy: String) {
					users(roles: $roles, orderBy: $orderBy) {
						id
						display_name
					}
      			}
		`, {
				roles: filterRoles,
				orderBy: 'display_name'
			}).then(result => {
				this.vans = result.users;
			}).catch(error => {
				console.log(error);
			});
		},
		getVansWithSupportProjects() {
			client.query(`
				query {
					getUsersWithSupportProjects {
						id
						display_name
					}
      			}
		`, {
			}).then(result => {
				this.vans = result.getUsersWithSupportProjects;
			}).catch(error => {
				console.log(error);
			});
		}
	}
};
</script>

<style scoped lang="scss">
.filter-item {
	display: flex; justify-content: space-between; margin-bottom: 0.5em;
}
</style>
